import { createTheme } from '@mui/material/styles';
import { remCalc } from '../../utils/remCalc';
import { getColor } from '../../utils/baseTheme';
import breakpoints from '../../utils/breakpoints';
const theme = createTheme({
	breakpoints: breakpoints,
});

const styles = {
	components: {
		MuiContainer: {
			styleOverrides: {
				root: {
					'&.FilterSet-root': {
						position: 'relative',
						zIndex: 2,
						paddingLeft: 0,
						paddingRight: 0,

						'.FilterSet-detail': {
							position: 'absolute',
							borderRadius: 25,
							width: '100%',
							border: `solid 3px ${getColor('blue', 200)}`,
							backgroundColor: getColor('blue', 700),
							transform: 'translateX(-3px) translateY(-3px)',
							padding: '10px 0px 50px 0px',
							[theme.breakpoints.up('sm')]: {
								padding: '10px 84px 50px 84px',
							},
							display: 'none',
							'&.Mui-expanded': {
								display: 'block',
							},

							'.FilterSet-textInput': {
								margin: 0,
								padding: 0,
								height: 'unset',
								backgroundColor: 'transparent',
								boxShadow: 'none',
								border: 'none',
								fontFamily: [
									'din-2014',
									'sans-serif',
								].join(', '),
								fontSize: 36,
								fontStyle: 'normal',
								fontWeight: 500,
								lineHeight: remCalc(40),
								color: getColor('white'),
								'::placeholder': {
									color: getColor('gray', 600),
									transition: 'all .2s ease-in-out',
								},
								'&:focus-visible': {
									outline: 'none',
									'::placeholder': {
										opacity: .25,
									},
								}
							},
						},

						'.FilterSet-title': {
							fontFamily: 'din-2014, sans-serif',
							fontSize: remCalc(36),
							fontWeight: 600,
							zIndex: 2,
							marginLeft: remCalc(-24),
							padding: '14px 0',
						},

						'.FilterSet-summary': {
							'.FilterSet-icon': {
								position: 'absolute',
								right: '-25px',
								[theme.breakpoints.up('sm')]: {
									right: '50px',
								},
							},
						},

						'.FilterSet-filters': {
							display: 'flex',
							marginBottom: remCalc(32),
							gap: remCalc(36),

							'.FilterSet-filter': {
								position: 'relative',

								'&.FilterSet-notSelected': {
									display: 'none',
								},

								'.FilterSet-filterButton': {
									minHeight: remCalc(74),
									backgroundColor: getColor('blue', 200),
									color: getColor('blue', 700),
									border: `solid 3px ${getColor('blue', 200)}`,
									borderRadius: 25,
									padding: '14px 24px !important',
									svg: {
										'*': {
											fill: 'currentColor',
										},
									},
								},
								'.FilterSet-clear': {
									top: remCalc(-5),
									right: remCalc(-5),
									backgroundColor: getColor('white'),
									borderRadius: '100%',
									padding: remCalc(1),
									transition: 'all .2s ease-in-out',
									color: getColor('blue', 700),
									'&:hover': {
										color: getColor('white'),
										backgroundColor: getColor('red', 500),
									},
									fontSize: remCalc(24),
									position: 'absolute',
									zIndex: 2,
									cursor: 'pointer',
								},
							},

							'&.FilterSet-isOpen': {
								'.FilterSet-clear': {
									display: 'none',
								},
								'.FilterSet-filterButton': {
									backgroundColor: getColor('blue', 700),
									color: getColor('white'),
									borderColor: getColor('blue', 700),
								},
							},
						},
					},
				},
			},
		},
	},
}

export default styles;